export default __webpack_public_path__ + "static/media/prbicon_MisDocumentos.03484a8a.svg";